import { render, staticRenderFns } from "./videoAddEDit.vue?vue&type=template&id=9d22eed8&scoped=true&"
import script from "./videoAddEDit.vue?vue&type=script&lang=js&"
export * from "./videoAddEDit.vue?vue&type=script&lang=js&"
import style0 from "./videoAddEDit.vue?vue&type=style&index=0&id=9d22eed8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d22eed8",
  null
  
)

export default component.exports